import React from "react";

const FeedbackPage = () => {
  return <h2>Feedback Page</h2>;
};

export default FeedbackPage;
